/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationCompanySearchCompanyOtherCcnsQuery from '../graphql/queries/GetSimulationCompanySearchCompanyOtherCcnsQuery.js';

const useGetSimulationCompanySearchCompanyOtherCcnsQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationCompanySearchCompanyOtherCcnsQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationCompanySearchCompanyOtherCcns: R.omit(['__typename'], data?.getSimulationCompanySearchCompanyOtherCcns_simulation_company || {})
  };
};

export default useGetSimulationCompanySearchCompanyOtherCcnsQuery;
